module.exports = __webpack_public_path__ + "images/save-c971d060.svg";